import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mainColor, UNIT } from '../../constants';
import LaunchingForm from '../LaunchingForm';
import IbanForm from '../IbanForm';
import ValidationStripeModal from '../ValidationStripeModal';
import {
  MISSED_PAYMENT_INFO,
  MISSED_SHOP_INFO,
  MISSED_STRIPE_INFO
} from '../../constants/dishopInfo';
import { setOpactity } from '../../utils/orderUtils';

const INITIAL_STATE = {
  showLaunchingModal: false
};
class LaunchingPanel extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  render() {
    const {
      stripeCompleted,
      customAccountId,
      firebaseCompleted,
      isProd,
      name,
      email,
      isAllShops
    } = this.props;
    const { showLaunchingModal } = this.state;

    return (
      !isAllShops &&
      (!firebaseCompleted || !customAccountId || !stripeCompleted) && (
        <>
          <div
            className='d-flex flex-column mt-2 py-3 mx-4'
            style={{
              borderRadius: UNIT,
              border: `1px solid`,
              borderColor: `${setOpactity('255, 180, 0', 0.5)}`,
              backgroundColor: `${setOpactity('255, 180, 0', 0.25)}`
            }}
          >
            <div className='mb-0 pl-4'>
              <h5 className='bold-text' style={{ color: mainColor.colorBlack }}>
                {firebaseCompleted
                  ? !customAccountId
                    ? MISSED_PAYMENT_INFO.title
                    : !stripeCompleted && MISSED_STRIPE_INFO.title
                  : MISSED_SHOP_INFO.title}
              </h5>
            </div>
            <div className='pl-4'>
              <p style={{ color: mainColor.colorBlack }}>
                Vous devez rentrer ces informations avant de pouvoir commencer à vendre vos
                produits.
                <br />
                <div
                  onClick={() => this.setState({ showLaunchingModal: true })}
                  role='button'
                  aria-hidden='true'
                  style={{ color: mainColor.secondaryColor, textDecoration: 'underline' }}
                >
                  {firebaseCompleted
                    ? !customAccountId
                      ? MISSED_PAYMENT_INFO.buttonText
                      : !stripeCompleted && MISSED_STRIPE_INFO.buttonText
                    : MISSED_SHOP_INFO.buttonText}
                </div>
              </p>
            </div>
          </div>

          <LaunchingForm
            showLaunchingModal={showLaunchingModal && !firebaseCompleted}
            onClose={() => this.setState({ showLaunchingModal: false })}
          />
          <IbanForm
            showLaunchingModal={showLaunchingModal && !customAccountId && firebaseCompleted}
            email={email}
            name={name}
            isProd={isProd}
            onClose={() => this.setState({ showLaunchingModal: false })}
          />
          <ValidationStripeModal
            onClose={() => this.setState({ showLaunchingModal: false })}
            showLaunchingModal={
              showLaunchingModal && !stripeCompleted && customAccountId && firebaseCompleted
            }
          />
        </>
      )
    );
  }
}
function mapStateToProps({ user, firebaseRealTime }) {
  const { isAuthenticated, isInitializing, dataHelpModal = {}, initializedApp, isAllShops } = user;
  const { link, isOpen } = dataHelpModal;
  const { shop = {}, generalConfig } = firebaseRealTime;
  const { servicePrice = {}, configuration = {}, name, support = {} } = shop;
  const { customAccountId } = servicePrice;
  const { domain } = generalConfig;
  const { email } = support;
  const { completed = {} } = configuration;
  const { stripe: stripeCompleted, firebase: firebaseCompleted } = completed;
  const isProd = domain ? !domain.includes('dev-') : false;
  return {
    isAuthenticated,
    isInitializing,
    firebaseCompleted,
    customAccountId,
    stripeCompleted,
    initializedApp,
    email,
    name,
    isProd,
    isOpen,
    link,
    isAllShops
  };
}
export default connect(mapStateToProps, null)(LaunchingPanel);
